export class DepartmentUser {
  constructor(
    public id: number,
    public departmentId: number,
    public userId: number
  ) {}

  public static get EMPTY(): DepartmentUser {
    return new DepartmentUser(0, 0, 0);
  }
}
